import { createContext, useContext } from "react";

import type { ExpenseScope } from "../../lib/api/expenses";

export type ExpensesFilterContextValue = {
    scope: ExpenseScope;
    storeName: string;
    year: number;
    month: number;
    statsMonths: number[];
    effectiveStoreName: string | null;
    storeOptions: string[];
    canManage: boolean;
    setScope: (scope: ExpenseScope) => void;
    setStoreName: (storeName: string) => void;
    setYear: (year: number) => void;
    setMonth: (month: number) => void;
    setStatsMonths: (months: number[]) => void;
};

export const ExpensesFilterContext = createContext<ExpensesFilterContextValue | null>(null);

export function useExpensesFilter() {
    const value = useContext(ExpensesFilterContext);

    if (!value) {
        throw new Error("useExpensesFilter изисква общия филтър на Разходи.");
    }

    return value;
}
